(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kierin-discovery-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kierin-discovery-builder')) {
  customElements.define('kierin-discovery-builder',class extends HTMLElement {
   connectedCallback() {
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.field = document.getElementById(`DiscoveryChoices-${this.dataset.formId}`);
    this.productInfo = this.closest('product-info');
    this.addEventListener('change',event=>{
     if(!event.target.matches('[data-scent-choice]'))return;
     const selected=this.choices();
     if(selected.length>this.maximum()) {
      event.target.checked=false;
      this.querySelector('[data-choice-count]').textContent=this.dataset.limitMessage.replace('[max]',this.maximum());
      return;
     }
     this.field.value=this.choices().map(input=>input.value).join(', ');
     this.field.dispatchEvent(new Event('input',{bubbles:true}));
     this.updateCount();
    },{signal});
    this.querySelector('[data-curate]').addEventListener('click',()=>{
      this.field.value='Best Sellers';
      this.querySelectorAll('[data-scent-choice]').forEach(input=>input.checked=false);
      this.field.dispatchEvent(new Event('input',{bubbles:true}));
      this.updateCount();
      this.field.focus();
    },{signal});
    this.productInfo?.addEventListener('change',event=>{
      if(event.target.closest('variant-selects'))this.updateCount();
    },{signal});
    this.field.addEventListener('input',event=>{
      if(event.isTrusted){
        this.querySelectorAll('[data-scent-choice]').forEach(input=>input.checked=false);
      }
      this.updateCount();
    },{signal});
    this.closest('form')?.addEventListener('submit',event=>{
      this.updateCount();
      if(!this.field.checkValidity()){
        event.preventDefault();
        event.stopImmediatePropagation();
        this.field.reportValidity();
        this.field.focus();
      }
    },{capture:true,signal});
    this.updateCount();
   }
   disconnectedCallback(){this.controller?.abort();}
   choices(){return Array.from(this.querySelectorAll('[data-scent-choice]:checked'));}
   maximum(){
    if(this.dataset.productHandle==='discovery-perfume-set-travel-spray-trio')return 3;
    const value=this.productInfo?.querySelector('variant-selects input:checked')?.value || this.productInfo?.querySelector('variant-selects select')?.value || '';
    return value.includes('12') ? 12 : 6;
   }
   updateCount(){
    const count=this.choices().length,max=this.maximum();
    const value=this.field.value.trim();
    let message=this.dataset.counter.replace('[count]',count).replace('[max]',max);
    if(count===0 && /^best sellers$/i.test(value)) message=this.dataset.curatedMessage.replace('[max]',max);
    else if(count===0 && value) message=this.dataset.manualMessage.replace('[max]',max);
    else if(count===max) message=this.dataset.readyMessage.replace('[max]',max);
    else if(count>max) message+=' '+this.dataset.limitMessage.replace('[max]',max);
    this.querySelector('[data-choice-count]').textContent=message;
    const error = !this.field.value.trim() ? this.dataset.requiredMessage : count>0 && count!==max ? this.dataset.exactMessage.replace('[max]',max) : '';
    this.field.setCustomValidity(error);
   }
  });
 }
  } catch(e) { console.error(e); }
})();

})();
